import { datasetDetailPageSizes } from "constants/defaultValues";
import axios from "../api";
import { coreToolAxios } from "../api";
import { getCookie } from "helpers/Utils";
const token = getCookie("Bearer");

export function getListDatasetDetailApi({
  dataset_id,
  pageSize = datasetDetailPageSizes[0],
  currentPage = 1,
  searchAdvanced = null,
}) {
  return axios.post(
    "/dataset/get-dataset-details",
    { search: searchAdvanced },
    {
      params: {
        dataset_id,
        currentPage,
        pageSize,
      },
    },
  );
}

export function getListPermissionByRole({ projectId, datasetId, sourceId }) {
  return axios.get("/users/permissions", {
    params: {
      projectId,
      ...(datasetId && { datasetId }),
      ...(sourceId && { sourceId }),
    },
  });
}

export function deleteDatasetDetailsApi({ labelSources, projectType }) {
  return axios.post("/dataset/delete-dataset-detail", {
    labelSources,
    projectType,
  });
}

export function getModuleCodeApi({ projectId, userId }) {
  return coreToolAxios.get("/module-code", {
    params: { projectId, userId },
    headers: {
      "Content-Type": "application/json",
      Authorization: `JWT ${token}`,
    },
  });
}

export function getDataByAdvancedSearch(data) {
  return axios.post("dataset/advanced-search", data);
}

export function updateStatusImageApi({ sourceId, status }) {
  return axios.put(
    `/label-source/${sourceId}`,
    {
      status,
    },
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    },
  );
}

export function bulkUpdateStatusApi(data) {
  return axios.put("/label-source/status/batch", data, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });
}

export function getTargetLabels({ projectId }) {
  return axios.get("/label-type", {
    params: { projectId, pageSize: 1000 },
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });
}

export function autoLabelsApi(data) {
  return axios.post("/label-point/auto-label/bulk", data, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });
}
